import SimpleText from './component'
import { Currency } from './components/currency'

export const Text = Object.assign(SimpleText, {
  Currency,
})
